import { getCookie, setCookie } from "./index";

export default class ParamsController {
  constructor() {
    this.params = new URL(window.location.href).searchParams;
  }

  handleIDev() {
    const paramName = "idev_id";
    const cookieName = "idevId";
    const idev = this.params.get(paramName);

    if (idev) {
      const currentCookie = getCookie(cookieName);

      if (!currentCookie || currentCookie !== idev) {
        setCookie(cookieName, idev, 30);
      }
    }
  }
}
